export default "__VITE_ASSET__Dj7cDr9u__"